import request from '@/utils/request'
export const getTableData = params =>
  request.get('/fs/customer-api/company-finances-css/page', params)
export const templateDownload = () =>
  request.get(
    '/fs/customer-api/company-finances-css/template/pull',
    {},
    { responseType: 'blob' },
  )
export const addCompanyFinances = params =>
  request.post('/fs/customer-api/company-finances-css/addCssReport', params)
export const removeItem = id =>
  request.delete(`/fs/customer-api/company-finances-css/${id}`)
